import * as React from 'react';
import './ProfessionalDisciplinePage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { IProfessionalDisciplineReduxFormState, initialProfessionalDisciplineState } from "../../../reducers/reactReduxForms/professionalDiscipline";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput } from "../../../components/form/index";
import * as ProfessionalDisciplineActions from '../../../actions/professionalDisciplines';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { LookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';
interface IProfessionalDisciplinePageParams {
  professionalDisciplineId: number;
}
interface IProfessionalDisciplinePageProps {
  form: Dtos.ProfessionalDiscipline & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: IProfessionalDisciplineReduxFormState;
  location: Location;
  professionalDisciplineId: number;
  match: match<IProfessionalDisciplinePageParams>;
  history: History;

  // From state
  professionalDiscipline: Dtos.ProfessionalDiscipline;
  lookups: Dtos.Lookup[];
  loadingProfessionalDiscipline: boolean;
  loadProfessionalDisciplineSuccess: boolean;
  loadProfessionalDisciplineFailure: boolean;
  savingProfessionalDiscipline: boolean;
  saveProfessionalDisciplineSuccess: boolean;
  saveProfessionalDisciplineFailure: boolean;
  creatingProfessionalDiscipline: boolean;
  createProfessionalDisciplineSuccess: boolean;
  createProfessionalDisciplineFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
}
interface IProfessionalDisciplinePageActions {
  clearProfessionalDiscipline: ProfessionalDisciplineActions.IProfessionalDisciplineClearActionCreator;
  loadProfessionalDiscipline: ProfessionalDisciplineActions.IProfessionalDisciplineLoadByIdActionCreator;
  saveProfessionalDiscipline: ProfessionalDisciplineActions.IProfessionalDisciplineSaveActionCreator;
  createProfessionalDiscipline: ProfessionalDisciplineActions.IProfessionalDisciplineCreateActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type ProfessionalDisciplinePageProps = IProfessionalDisciplinePageProps & IProfessionalDisciplinePageActions;
const reduxFormName: string = "reduxForms.professionalDiscipline";
class ProfessionalDisciplinePage extends React.PureComponent<ProfessionalDisciplinePageProps, any> {
  constructor(props: ProfessionalDisciplinePageProps) {
    super(props);
    this.clearProfessionalDiscipline = this.clearProfessionalDiscipline.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
  }
  componentDidMount() {
    const {
      loadProfessionalDiscipline,
      professionalDisciplineId,
      createProfessionalDiscipline
    } = this.props;
    if (professionalDisciplineId) {
      loadProfessionalDiscipline(professionalDisciplineId);
    } else if (!professionalDisciplineId) {
      createProfessionalDiscipline();
    }
  }
  componentWillReceiveProps(nextProps: ProfessionalDisciplinePageProps) {}
  componentDidUpdate(prevProps: ProfessionalDisciplinePageProps, prevState) {
    const {
      professionalDisciplineId,
      professionalDiscipline,
      form,
      navigate,
      loadProfessionalDiscipline,
      loadingProfessionalDiscipline,
      loadProfessionalDisciplineSuccess,
      createProfessionalDiscipline,
      creatingProfessionalDiscipline,
      createProfessionalDisciplineSuccess,
      savingProfessionalDiscipline,
      saveProfessionalDisciplineSuccess,
      validationFailures
    } = this.props;
    if (professionalDisciplineId && prevProps.professionalDisciplineId != professionalDisciplineId) {
      loadProfessionalDiscipline(professionalDisciplineId);
    } else if (!professionalDisciplineId && prevProps.professionalDisciplineId) {
      createProfessionalDiscipline();
    }
    if (!loadingProfessionalDiscipline && prevProps.loadingProfessionalDiscipline) {
      if (loadProfessionalDisciplineSuccess) {
        this.loadForm();
      }
    }
    if (!savingProfessionalDiscipline && prevProps.savingProfessionalDiscipline) {
      if (saveProfessionalDisciplineSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/settings/general/professionaldisciplines");
        } else if (!form.saveAndReturn && professionalDisciplineId && professionalDisciplineId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !professionalDisciplineId && professionalDiscipline && professionalDiscipline.id > 0) {
          navigate("/settings/general/professionaldisciplines/" + professionalDiscipline.id);
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingProfessionalDiscipline && prevProps.creatingProfessionalDiscipline) {
      if (createProfessionalDisciplineSuccess) {
        this.loadForm();
      }
    }
  }
  componentWillUpdate(nextProps: ProfessionalDisciplinePageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearProfessionalDiscipline();
    loadForm(reduxFormName, initialProfessionalDisciplineState);
    resetForm(reduxFormName);
  }
  clearProfessionalDiscipline() {
    this.props.clearProfessionalDiscipline();
  }
  showProfessionalDiscipline(): boolean {
    const {
      loadingProfessionalDiscipline,
      loadProfessionalDisciplineSuccess
    } = this.props;
    if (!loadingProfessionalDiscipline && loadProfessionalDisciplineSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingProfessionalDiscipline
    } = this.props;
    return <LookupsLayout loading={loadingProfessionalDiscipline} permission={Dtos.Permission.ProfessionalDisciplinesView} data-sentry-element="LookupsLayout" data-sentry-component="ProfessionalDisciplinePage" data-sentry-source-file="ProfessionalDisciplinePage.tsx">
            {this.renderContent()}
        </LookupsLayout>;
  }
  renderContent() {
    const {
      form,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      savingProfessionalDiscipline,
      permissions
    } = this.props;
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.ProfessionalDisciplinesUpdate, Dtos.Permission.ProfessionalDisciplinesCreate);
    const formDisabled: boolean = !hasPermission || savingProfessionalDiscipline || formState && formState.formStatus == Dtos.FormStatus.Disabled;
    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      value: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled
      },
      rank: {
        type: RegistrationComponent.RegistrationControl,
        inputType: NumberFormInput,
        inputDisabled: formDisabled
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " "
      }
    };
    return <div>
            <h1>Professional Discipline</h1>
            <Form model={reduxFormName} onSubmit={(val, event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>
                {renderFormControls(form, "professionalDiscipline", formComponents, lookups, validationFailures, formProperties, changeForm)}
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit
                    </button>

                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                </div>
            </Form>

        </div>;
  }
  renderErrorAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was <strong> not </strong> saved.
            </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.ProfessionalDiscipline) {
    const {
      saveProfessionalDiscipline
    } = this.props;
    if (data) {
      let changes: Dtos.ProfessionalDiscipline = ({} as Dtos.ProfessionalDiscipline);
      saveProfessionalDiscipline(Object.assign({
        ...data
      }, changes));
    }
  }
  handleOnSubmitFailed(data: Dtos.ProfessionalDiscipline) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      navigate
    } = this.props;
    navigate("/settings/general/professionaldisciplines");
  }
  loadForm() {
    const {
      loadForm,
      professionalDiscipline
    } = this.props;
    let extraData: Dtos.ProfessionalDiscipline = ({} as Dtos.ProfessionalDiscipline);
    loadForm(reduxFormName, Object.assign({
      ...professionalDiscipline
    }, extraData));
  }
}
const mapStateToProps = (state: ITmdState, ownProps: ProfessionalDisciplinePageProps): IProfessionalDisciplinePageProps => {
  let professionalDiscipline: Dtos.ProfessionalDiscipline | undefined = !(state.professionalDisciplines.formData instanceof Array) ? state.professionalDisciplines.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    professionalDisciplineId: ownProps.match && ownProps.match.params.professionalDisciplineId && ownProps.match.params.professionalDisciplineId.toString() != "create" ? ownProps.match.params.professionalDisciplineId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    professionalDiscipline: professionalDiscipline!,
    loadingProfessionalDiscipline: state.professionalDisciplines.loadState && state.professionalDisciplines.loadState.status == RequestState.Pending,
    loadProfessionalDisciplineSuccess: state.professionalDisciplines.loadState && state.professionalDisciplines.loadState.status == RequestState.Success,
    loadProfessionalDisciplineFailure: state.professionalDisciplines.loadState && state.professionalDisciplines.loadState.status == RequestState.Failure,
    savingProfessionalDiscipline: state.professionalDisciplines.saveState && state.professionalDisciplines.saveState.status == RequestState.Pending,
    saveProfessionalDisciplineSuccess: state.professionalDisciplines.saveState && state.professionalDisciplines.saveState.status == RequestState.Success,
    saveProfessionalDisciplineFailure: state.professionalDisciplines.saveState && state.professionalDisciplines.saveState.status == RequestState.Failure,
    creatingProfessionalDiscipline: state.professionalDisciplines.createState && state.professionalDisciplines.createState.status == RequestState.Pending,
    createProfessionalDisciplineSuccess: state.professionalDisciplines.createState && state.professionalDisciplines.createState.status == RequestState.Success,
    createProfessionalDisciplineFailure: state.professionalDisciplines.createState && state.professionalDisciplines.createState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    lookups: [],
    form: state.reduxForms.professionalDiscipline,
    formState: state.professionalDisciplines.formState,
    formProperties: state.professionalDisciplines.formProperties,
    reduxFormState: state.reduxForms.formState.professionalDiscipline,
    validationFailures: professionalDiscipline ? state.professionalDisciplines.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): IProfessionalDisciplinePageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadProfessionalDiscipline: bindActionCreators(ProfessionalDisciplineActions.LoadProfessionalDisciplineById, dispatch),
    clearProfessionalDiscipline: bindActionCreators(ProfessionalDisciplineActions.Clear, dispatch),
    saveProfessionalDiscipline: bindActionCreators(ProfessionalDisciplineActions.SaveProfessionalDiscipline, dispatch),
    createProfessionalDiscipline: bindActionCreators(ProfessionalDisciplineActions.CreateProfessionalDiscipline, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfessionalDisciplinePage);